"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleBufferTimeUnit = exports.DurationTimeUnit = exports.SchedulerBufferTime = void 0;
var SchedulerBufferTime;
(function (SchedulerBufferTime) {
    SchedulerBufferTime["NONE"] = "NONE";
    SchedulerBufferTime["MINUTE5"] = "MINUTE5";
    SchedulerBufferTime["MINUTE10"] = "MINUTE10";
    SchedulerBufferTime["MINUTE15"] = "MINUTE15";
    SchedulerBufferTime["MINUTE20"] = "MINUTE20";
    SchedulerBufferTime["MINUTE25"] = "MINUTE25";
    SchedulerBufferTime["MINUTE30"] = "MINUTE30";
    SchedulerBufferTime["MINUTE35"] = "MINUTE35";
    SchedulerBufferTime["MINUTE40"] = "MINUTE40";
    SchedulerBufferTime["MINUTE45"] = "MINUTE45";
    SchedulerBufferTime["MINUTE50"] = "MINUTE50";
    SchedulerBufferTime["MINUTE55"] = "MINUTE55";
    SchedulerBufferTime["MINUTE60"] = "MINUTE60";
})(SchedulerBufferTime = exports.SchedulerBufferTime || (exports.SchedulerBufferTime = {}));
var DurationTimeUnit;
(function (DurationTimeUnit) {
    DurationTimeUnit["MINUTE"] = "MINUTE";
})(DurationTimeUnit = exports.DurationTimeUnit || (exports.DurationTimeUnit = {}));
var ScheduleBufferTimeUnit;
(function (ScheduleBufferTimeUnit) {
    ScheduleBufferTimeUnit["HOUR"] = "HOUR";
})(ScheduleBufferTimeUnit = exports.ScheduleBufferTimeUnit || (exports.ScheduleBufferTimeUnit = {}));
